module.exports = __webpack_public_path__ + "static/IntroductionPattern-4ba21253b3106bb956b06fab48745fe8.png";